/**
 * @param element Node element which you want to test.
 * @returns A boolean representing if the element is selected or not.
 */
export function isElementSelected(element: Node): boolean {
  if (!element) {
    return false
  }

  const selection = window.getSelection()

  if (!selection) {
    return false
  }

  const result: boolean = [...Array(selection.rangeCount)].some((_, index) =>
    selection.getRangeAt(index).intersectsNode(element)
  )

  return result
}
